import { useQuery } from '@tanstack/react-query'

import { getEnrollmentJourneyPreparation } from '../../../api/enrollments/get-enrollment-journey-preparation'
import { ItemNotFound } from '../../../components/elements/item-not-found'
import LoadingScreen from '../../../components/elements/loading/loading-screen'
import useEnrollment from '../../../lib/hooks/use-enrollment'

export default function ClientChildJourneyPreparationPage() {
  const { enrollment } = useEnrollment()

  const { data, isPending, error } = useQuery({
    queryKey: ['journey-preparation', enrollment?.id],
    queryFn: () => getEnrollmentJourneyPreparation(enrollment.id),
    enabled: !!enrollment?.id
  })

  if (error) return <ItemNotFound title="Aucune page trouvée" />
  if (isPending) return <LoadingScreen />

  return <div dangerouslySetInnerHTML={{ __html: data?.content || '' }} />
}
